import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DetailPageFrame,
  DetailPageShell,
  DetailScrollArea,
} from "./styles.scheduleGroupDetails";
import { ASNModalTitle } from "./styles.advanceShippingNoteDetails";
import {
  MarkEntryFormCard,
  MarkEntryFormState,
  MarkEntryHeader,
  MarkEntryHeaderTitle,
  MarkEntryInput,
  MarkEntryInputHint,
  OutcomeIconCircle,
  SwipeConfirmBar,
} from "./styles.publicMarkEntry";
import SwipeToMarkEntry from "./SwipeToMarkEntry";

const ENTRY_TOKEN_LENGTH = 6;

const VEHICLE_NUMBER_REGEX =
  /^(([A-Z]{2}\s?[0-9]{2}\s?(?:[A-Z]{1,3}\s?)?[0-9]{4})|([0-9]{2}\s?BH\s?[0-9]{4}\s?[A-Z]{1,2})|([A-Z]{2}\s?VA\s?[A-Z]{2}\s?[0-9]{4})|([0-9]{2}\s?[A-Z]\s?[0-9]{6}\s?[A-Z])|([0-9]{1,3}\s?(?:CD|CC|UN)\s?[0-9]{1,4}))$/i;

// Collects the entry token + vehicle number, then hands off to the shared
// markentry?code=... detail page (PublicMarkEntry), which fetches the ASN and owns the
// actual "swipe to mark entry" -> markarrived call. Vehicle number travels via router
// state since it's user-entered here, not part of the ASN response for a shared code.
const PublicMarkEntryQr = () => {
  const navigate = useNavigate();
  const [entryToken, setEntryToken] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");

  const isFormValid =
    entryToken.trim().length === ENTRY_TOKEN_LENGTH &&
    VEHICLE_NUMBER_REGEX.test(vehicleNumber.trim());

  const continueToMarkEntry = () => {
    if (!isFormValid) return;
    navigate(`/plan-shipment/markentry?code=${encodeURIComponent(entryToken.trim())}`, {
      state: { vehicleNumber: vehicleNumber.trim() },
    });
  };

  return (
    <DetailPageShell>
      <DetailPageFrame>
        <MarkEntryHeader>
          <MarkEntryHeaderTitle>Mark entry to warehouse</MarkEntryHeaderTitle>
        </MarkEntryHeader>

        <DetailScrollArea>
          <MarkEntryFormState>
            <OutcomeIconCircle>
              <img src="/logos/barrier.svg" alt="" />
            </OutcomeIconCircle>
            <ASNModalTitle>Add details to mark entry</ASNModalTitle>

            <MarkEntryFormCard>
              <MarkEntryInput
                type="text"
                maxLength={ENTRY_TOKEN_LENGTH}
                placeholder="6-digit entry token"
                value={entryToken}
                onChange={(event) =>
                  setEntryToken(event.target.value.slice(0, ENTRY_TOKEN_LENGTH))
                }
              />
              <MarkEntryInputHint>
                You must have received this from Hyperpure or your owner
              </MarkEntryInputHint>
              <MarkEntryInput
                type="text"
                placeholder="Vehicle number"
                value={vehicleNumber}
                onChange={(event) => setVehicleNumber(event.target.value.toUpperCase())}
              />
            </MarkEntryFormCard>
          </MarkEntryFormState>
        </DetailScrollArea>

        <SwipeConfirmBar>
          <SwipeToMarkEntry
            label="Swipe to mark entry"
            status=""
            onConfirm={continueToMarkEntry}
            disabled={!isFormValid}
          />
        </SwipeConfirmBar>
      </DetailPageFrame>
    </DetailPageShell>
  );
};

export default PublicMarkEntryQr;
